export default function Rates() {
  return (
    <section id="rates" className="py-20 bg-gradient-to-br from-teal-50 to-cyan-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Simple, Affordable Rates
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            No hidden fees, no surprises. Just straightforward weekly rates that work for your budget.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="bg-gradient-to-r from-teal-600 to-cyan-600 px-8 py-12 text-center">
              <div className="inline-block bg-white/20 backdrop-blur-sm px-6 py-2 rounded-full mb-4">
                <span className="text-white text-sm font-semibold">Weekly Rate</span>
              </div>
              <div className="flex items-center justify-center gap-2 mb-2">
                <span className="text-6xl md:text-7xl font-bold text-white">$250</span>
                <span className="text-2xl text-white/80">/week</span>
              </div>
              <p className="text-white/90 text-lg">All vehicles, one simple rate</p>
            </div>

            <div className="p-8 md:p-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">What's Included</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                    <i className="ri-shield-check-line text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Basic Insurance</h4>
                    <p className="text-sm text-gray-600">Standard coverage included in weekly rate</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                    <i className="ri-road-map-line text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Unlimited Mileage</h4>
                    <p className="text-sm text-gray-600">Drive as much as you need for work</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                    <i className="ri-tools-line text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Maintenance Support</h4>
                    <p className="text-sm text-gray-600">We handle regular maintenance</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                    <i className="ri-customer-service-2-line text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">24/7 Support</h4>
                    <p className="text-sm text-gray-600">Help when you need it most</p>
                  </div>
                </div>
              </div>

              <div className="mt-10 p-6 bg-gray-50 rounded-lg">
                <p className="text-sm text-gray-600 text-center">
                  <strong className="text-gray-900">Flexible Terms:</strong> Weekly rentals with option to extend. 
                  Perfect for gig workers who need reliable transportation without long-term commitments.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}